import { makeAutoObservable, observable } from 'mobx'

import { OrderCommentDTO } from 'sections/LKSection/modules/OrderModule/types'

export enum SendByType {
  owner = 'OWNER',
  admin = 'ADMIN',
}

export class OrderComment {
  @observable comment: string = ''
  @observable date: Date = new Date()
  @observable sendBy: SendByType = SendByType.admin

  constructor(props: OrderComment) {
    makeAutoObservable(this)
    Object.assign(this, props)
  }

  static create(dto: OrderCommentDTO) {
    return new OrderComment({
      comment: dto.comment,
      date: new Date(dto.dt),
      sendBy: dto.sendBy as SendByType,
    })
  }
}
